/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
  "/api/analytics/export": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Export documents analytics data
     * @description Exports aggregated documents analytics data for all customers. Returns one record per customer/targetSystem combination with aggregated metrics.
     */
    get: operations["getApiAnalyticsExport"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/connections": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get All Connections
     * @description Retrieves a list of all document connections across all customers.
     */
    get: operations["getApiConnections"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/connections/{customerId}": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Connections for Customer
     * @description Retrieves a list of document connections for a specific customer.
     */
    get: operations["getApiConnectionsByCustomerId"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/connections/{customerId}/{targetSystem}/archive": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Archive Connection
     * @description Archives a document connection by setting its state to archived and triggering a workflow to re-setup schedules. This operation is idempotent - archiving an already archived connection will succeed.
     */
    post: operations["postApiConnectionsByCustomerIdByTargetSystemArchive"];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/customers": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List all customers
     * @description Retrieves a paginated list of all customers with at least one active connection.
     */
    get: operations["getApiCustomers"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/customers/{customerId}/bills": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get bills for a customer
     * @description Retrieves a paginated list of bills for the specified customer.
     */
    get: operations["getApiCustomersByCustomerIdBills"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/customers/{customerId}/bills/{billId}": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get a specific bill
     * @description Retrieves a specific bill by its ID.
     */
    get: operations["getApiCustomersByCustomerIdBillsByBillId"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/customers/{customerId}/bills/{billId}/file": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Download bill file
     * @description Downloads the file for a specific bill from R2 storage.
     */
    get: operations["getApiCustomersByCustomerIdBillsByBillIdFile"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/customers/{customerId}/bills/{billId}/file-url": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get pre-signed URL for bill file
     * @description Returns a pre-signed URL for direct download of the bill file from R2 storage. The URL expires after 1 hour.
     */
    get: operations["getApiCustomersByCustomerIdBillsByBillIdFile-url"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/customers/{customerId}/bills/sync": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Trigger bills sync for a customer
     * @description Triggers bills synchronization workflow for all active target systems that the customer has connections for. Optionally accepts forceFullFetch parameter to trigger complete historical synchronization.
     */
    get: operations["getApiCustomersByCustomerIdBillsSync"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/customers/{customerId}/dump": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Dump the state of the customer
     * @description Retrieves the current state of the customer for debugging purposes.
     */
    get: operations["getApiCustomersByCustomerIdDump"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/customers/{customerId}/files": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get files for a customer
     * @description Retrieves a paginated list of files for the specified customer.
     */
    get: operations["getApiCustomersByCustomerIdFiles"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/customers/{customerId}/files/by-hash": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get bills and invoices by file hash
     * @description Finds all files matching the specified file hash and returns the bills and invoices that reference those files.
     */
    get: operations["getApiCustomersByCustomerIdFilesBy-hash"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/customers/{customerId}/files/sync": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Trigger files sync for a customer
     * @description Manually triggers the FilesSyncWorkflow to sync files for bills and invoices without fileId.
     */
    get: operations["getApiCustomersByCustomerIdFilesSync"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/customers/{customerId}/invoices": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get invoices for a customer
     * @description Retrieves a paginated list of invoices for the specified customer.
     */
    get: operations["getApiCustomersByCustomerIdInvoices"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/customers/{customerId}/invoices/{invoiceId}": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get a specific invoice
     * @description Retrieves a specific invoice by its ID.
     */
    get: operations["getApiCustomersByCustomerIdInvoicesByInvoiceId"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/customers/{customerId}/invoices/{invoiceId}/file": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Download invoice file
     * @description Downloads the file for a specific invoice from R2 storage.
     */
    get: operations["getApiCustomersByCustomerIdInvoicesByInvoiceIdFile"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/customers/{customerId}/invoices/{invoiceId}/file-url": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get pre-signed URL for invoice file
     * @description Returns a pre-signed URL for direct download of the invoice file from R2 storage. The URL expires after 1 hour.
     */
    get: operations["getApiCustomersByCustomerIdInvoicesByInvoiceIdFile-url"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/customers/{customerId}/invoices/sync": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Trigger invoices sync for a customer
     * @description Triggers invoices synchronization workflow for all active target systems that the customer has connections for. Optionally accepts forceFullFetch parameter to trigger complete historical synchronization.
     */
    get: operations["getApiCustomersByCustomerIdInvoicesSync"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/customers/{customerId}/setup-schedule": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Setup workflow schedules for customer
     * @description Initializes or resets workflow schedules for a customer based on all active connections. This creates recurring schedules for bills sync, invoices sync, and files sync. Use this endpoint to recover from scheduling issues or to add new workflow types for existing customers.
     */
    post: operations["postApiCustomersByCustomerIdSetup-schedule"];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/target-systems": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List Target Systems
     * @description Retrieves a list of all supported accounting target systems
     */
    get: operations["getApiTarget-systems"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/target-systems/{targetSystemId}": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get Target System
     * @description Retrieves details of a specific target system by ID
     */
    get: operations["getApiTarget-systemsByTargetSystemId"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/redirect/{customerId}/{targetSystem}": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations["getRedirectByCustomerIdByTargetSystem"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
}
export type webhooks = Record<string, never>;
export interface components {
  schemas: {
    /** @description Details of an HTTP 400 error. */
    ApiErrorDetails400: {
      /** @description The underlying cause of the error, if available. Nullable. */
      cause?: unknown;
      /**
       * @description A code identifying the type of error (e.g., "HTTPException", "Validation Error").
       * @example HTTPException
       */
      errorCode: string;
      /**
       * @description A human-readable message describing the error.
       * @example Bad Request
       */
      message: string;
      /**
       * @description The HTTP status code associated with the error.
       * @example 400
       * @constant
       */
      statusCode: 400;
    };
    /** @description Details of an HTTP 401 error. */
    ApiErrorDetails401: {
      /** @description The underlying cause of the error, if available. Nullable. */
      cause?: unknown;
      /**
       * @description A code identifying the type of error (e.g., "HTTPException", "Validation Error").
       * @example HTTPException
       */
      errorCode: string;
      /**
       * @description A human-readable message describing the error.
       * @example Unauthorized
       */
      message: string;
      /**
       * @description The HTTP status code associated with the error.
       * @example 401
       * @constant
       */
      statusCode: 401;
    };
    /** @description Details of an HTTP 404 error. */
    ApiErrorDetails404: {
      /** @description The underlying cause of the error, if available. Nullable. */
      cause?: unknown;
      /**
       * @description A code identifying the type of error (e.g., "HTTPException", "Validation Error").
       * @example HTTPException
       */
      errorCode: string;
      /**
       * @description A human-readable message describing the error.
       * @example Not Found
       */
      message: string;
      /**
       * @description The HTTP status code associated with the error.
       * @example 404
       * @constant
       */
      statusCode: 404;
    };
    /** @description Details of an HTTP 500 error. */
    ApiErrorDetails500: {
      /** @description The underlying cause of the error, if available. Nullable. */
      cause?: unknown;
      /**
       * @description A code identifying the type of error (e.g., "HTTPException", "Validation Error").
       * @example InternalServerError
       */
      errorCode: string;
      /**
       * @description A human-readable message describing the error.
       * @example Internal Server Error
       */
      message: string;
      /**
       * @description The HTTP status code associated with the error.
       * @example 500
       * @constant
       */
      statusCode: 500;
    };
    Bill: {
      billDate: string;
      billNumber: string;
      createdAt: string;
      currency: string;
      /** @description File metadata if available */
      file: {
        contentType: string;
        createdAt: string;
        fileHash: string;
        fileName: string;
        fileSize: number;
        id: string;
        updatedAt: string;
      } | null;
      id: string;
      name: string;
      targetSystem: string;
      totalAmount: number;
      updatedAt: string;
    };
    Connection: {
      /** @description ISO timestamp when the connection was archived */
      archivedAt: string | null;
      /** @description ISO timestamp when the connection was created */
      createdAt: string;
      /** @description The customer identifier */
      customerId: string;
      /** @description HTTP status code (401 or 403) */
      errorCode: number | null;
      /** @description ISO timestamp when auth error occurred */
      erroredAt: string | null;
      /** @description ISO date for historical data retrieval start */
      historicalStartDate: string | null;
      /** @description ISO timestamp when bills were last inserted */
      lastBillsAddedAt: string | null;
      /** @description ISO timestamp of the last successful bills sync workflow run */
      lastBillsSyncedAt: string | null;
      /** @description ISO timestamp when invoices were last inserted */
      lastInvoicesAddedAt: string | null;
      /** @description ISO timestamp of the last successful invoices sync workflow run */
      lastInvoicesSyncedAt: string | null;
      /** @description The reference identifier for the connection */
      reference: string;
      /**
       * @description The current state of the connection
       * @enum {string}
       */
      state: "pending" | "active" | "errored" | "archived";
      /** @description The target system (e.g., MAESN, DATEV) */
      targetSystem: string;
      /** @description ISO timestamp when the connection was last updated */
      updatedAt: string;
    };
    ConnectionsAnalyticsRecord: {
      /** @description ISO timestamp when archived (empty if null) */
      archivedAt: string;
      /** @description ISO timestamp when created */
      createdAt: string;
      /** @description Customer UUID */
      customerId: string;
      /** @description HTTP status code for auth error (empty if null) */
      errorCode: string;
      /** @description ISO timestamp when auth error occurred (empty if null) */
      erroredAt: string;
      /** @description ISO date for historical data retrieval start (empty if null) */
      historicalStartDate: string;
      /** @description ISO timestamp when bills were last inserted (empty if null) */
      lastBillsAddedAt: string;
      /** @description ISO timestamp of last successful bills sync workflow run (empty if null) */
      lastBillsSyncedAt: string;
      /** @description ISO timestamp when invoices were last inserted (empty if null) */
      lastInvoicesAddedAt: string;
      /** @description ISO timestamp of last successful invoices sync workflow run (empty if null) */
      lastInvoicesSyncedAt: string;
      /** @description Connection state: pending, active, errored */
      state: string;
      /** @description Target system identifier (e.g., MAESN, LEXOFFICE) */
      targetSystem: string;
      /** @description ISO timestamp when last updated */
      updatedAt: string;
    };
    Customer: {
      /**
       * Format: uuid
       * @description Unique identifier for the customer
       * @example 945163ef-cbb2-467e-a74d-b8b03d065aa0
       */
      customerId: string;
      /**
       * @description The oldest historical start date across all active connections for this customer (defaults to today if none set)
       * @example 2023-01-01
       */
      oldestHistoricalStartDate: string;
    };
    DocumentsAnalyticsExportResponse: {
      connections: components["schemas"]["ConnectionsAnalyticsRecord"][];
      /** @description Total number of customers processed */
      customerCount: number;
      /** @description Number of customers that failed to process */
      failedCount: number;
      records: components["schemas"]["DocumentsAnalyticsRecord"][];
    };
    DocumentsAnalyticsRecord: {
      /** @description Total count of bills for this customer/targetSystem */
      billsCount: number;
      /** @description Count of bills with fileId not null */
      billsWithFiles: number;
      /** @description Customer UUID */
      customerId: string;
      /** @description Total count of files (across all targetSystems) */
      filesCount: number;
      /** @description Total count of invoices for this customer/targetSystem */
      invoicesCount: number;
      /** @description Count of invoices with fileId not null */
      invoicesWithFiles: number;
      /** @description Target system identifier (e.g., MAESN, LEXOFFICE) */
      targetSystem: string;
    };
    DumpData: {
      /** @description Durable Object storage information */
      storage: components["schemas"]["DumpStorageInfo"];
      tables: components["schemas"]["DumpTableInfo"][];
    };
    DumpStorageInfo: {
      /** @description ISO 8601 timestamp of next scheduled alarm, or null if no alarm set */
      nextAlarm: string | null;
      /** @description Current workflow schedules stored in Durable Object */
      workflowSchedule: components["schemas"]["WorkflowScheduleInfo"][] | null;
    };
    DumpTableInfo: {
      data: unknown[];
      name: string;
      schema: string;
    };
    ErrorResponse400: {
      error: components["schemas"]["ApiErrorDetails400"];
      /**
       * @description Indicates that the API request failed.
       * @example false
       * @constant
       */
      success: false;
    };
    ErrorResponse401: {
      error: components["schemas"]["ApiErrorDetails401"];
      /**
       * @description Indicates that the API request failed.
       * @example false
       * @constant
       */
      success: false;
    };
    ErrorResponse404: {
      error: components["schemas"]["ApiErrorDetails404"];
      /**
       * @description Indicates that the API request failed.
       * @example false
       * @constant
       */
      success: false;
    };
    ErrorResponse500: {
      error: components["schemas"]["ApiErrorDetails500"];
      /**
       * @description Indicates that the API request failed.
       * @example false
       * @constant
       */
      success: false;
    };
    File: {
      contentType: string;
      createdAt: string;
      fileHash: string;
      fileName: string;
      fileSize: number;
      id: string;
      r2Key: string;
      updatedAt: string;
    };
    FileHashReferencesResponse: {
      bills: components["schemas"]["Bill"][];
      invoices: components["schemas"]["Invoice"][];
    };
    FileUrlResponse: {
      /** @description MIME type of the file */
      contentType: string;
      /** @description URL expiry time in seconds */
      expiresIn: number;
      /**
       * Format: uri
       * @description Pre-signed URL for direct file download
       */
      url: string;
    };
    Invoice: {
      createdAt: string;
      currency: string;
      /** @description File metadata if available */
      file: {
        contentType: string;
        createdAt: string;
        fileHash: string;
        fileName: string;
        fileSize: number;
        id: string;
        updatedAt: string;
      } | null;
      id: string;
      invoiceDate: string;
      invoiceNumber: string;
      name: string;
      targetSystem: string;
      totalAmount: number;
      updatedAt: string;
    };
    /** @description Standard pagination information */
    PaginationInfo: {
      /**
       * @description Maximum number of items returned per page
       * @example 10
       */
      limit: number;
      /**
       * @description Number of items skipped from the beginning
       * @example 0
       */
      offset: number;
      /**
       * @description Total number of items available
       * @example 100
       */
      total: number;
    };
    TargetSystem: {
      /** @description API capabilities supported by this target system */
      capabilities: components["schemas"]["TargetSystemCapabilities"];
      /**
       * @description Unique identifier for the target system
       * @example lexware-office
       */
      id: string;
      /** @description Locale-specific content for the target system */
      locales: {
        /** @description German locale content */
        de: {
          /**
           * Format: uri
           * @description Optional URL to localized help article for the target system
           * @example https://intercom-help.eu/smarta-steuern/en/articles/419759-how-to-connect-your-lexware-office-account-with-your-smarta-profile
           */
          helpUrl?: string;
          /**
           * @description Localized display name of the target system
           * @example Lexware Office XL
           */
          name: string;
        };
        /** @description English locale content */
        en: {
          /**
           * Format: uri
           * @description Optional URL to localized help article for the target system
           * @example https://intercom-help.eu/smarta-steuern/en/articles/419759-how-to-connect-your-lexware-office-account-with-your-smarta-profile
           */
          helpUrl?: string;
          /**
           * @description Localized display name of the target system
           * @example Lexware Office XL
           */
          name: string;
        };
      };
      /**
       * Format: uri
       * @description URL to the target system logo
       * @example https://cdn.smarta.tax/images/target-systems/lexware-office-logo.svg
       */
      logoUrl: string;
    };
    TargetSystemCapabilities: {
      /**
       * @description Supported order field for invoices API endpoint
       * @example updatedDate
       * @enum {string}
       */
      invoicesOrderField: "createdDate" | "updatedDate";
      /**
       * @description Whether bookingProposals endpoint supports bookingType INVOICE
       * @example true
       */
      supportsInvoiceBookingType: boolean;
    };
    WorkflowScheduleInfo: {
      /** @description Interval between executions in milliseconds */
      intervalMs: number;
      /** @description Unix timestamp of last execution */
      lastExecutionTime?: number;
      /** @description Unix timestamp of next execution */
      nextExecutionTime: number;
      options: {
        params: {
          /** @description Customer UUID */
          customerId: string;
          /** @description Target system (e.g., lexware-office). Not present for filesSync. */
          targetSystem?: string;
        };
      }[];
      /** @description Schedule status (active, paused, failed) */
      status: string;
      /** @description Workflow type (e.g., billsSync, invoicesSync, filesSync) */
      type: string;
    };
  };
  responses: never;
  parameters: never;
  requestBodies: never;
  headers: never;
  pathItems: never;
}
export type ApiErrorDetails400 = components["schemas"]["ApiErrorDetails400"];
export type ApiErrorDetails401 = components["schemas"]["ApiErrorDetails401"];
export type ApiErrorDetails404 = components["schemas"]["ApiErrorDetails404"];
export type ApiErrorDetails500 = components["schemas"]["ApiErrorDetails500"];
export type Bill = components["schemas"]["Bill"];
export type Connection = components["schemas"]["Connection"];
export type ConnectionsAnalyticsRecord =
  components["schemas"]["ConnectionsAnalyticsRecord"];
export type Customer = components["schemas"]["Customer"];
export type DocumentsAnalyticsExportResponse =
  components["schemas"]["DocumentsAnalyticsExportResponse"];
export type DocumentsAnalyticsRecord =
  components["schemas"]["DocumentsAnalyticsRecord"];
export type DumpData = components["schemas"]["DumpData"];
export type DumpStorageInfo = components["schemas"]["DumpStorageInfo"];
export type DumpTableInfo = components["schemas"]["DumpTableInfo"];
export type ErrorResponse400 = components["schemas"]["ErrorResponse400"];
export type ErrorResponse401 = components["schemas"]["ErrorResponse401"];
export type ErrorResponse404 = components["schemas"]["ErrorResponse404"];
export type ErrorResponse500 = components["schemas"]["ErrorResponse500"];
export type File = components["schemas"]["File"];
export type FileHashReferencesResponse =
  components["schemas"]["FileHashReferencesResponse"];
export type FileUrlResponse = components["schemas"]["FileUrlResponse"];
export type Invoice = components["schemas"]["Invoice"];
export type PaginationInfo = components["schemas"]["PaginationInfo"];
export type TargetSystem = components["schemas"]["TargetSystem"];
export type TargetSystemCapabilities =
  components["schemas"]["TargetSystemCapabilities"];
export type WorkflowScheduleInfo =
  components["schemas"]["WorkflowScheduleInfo"];
export type $defs = Record<string, never>;
export interface operations {
  getApiAnalyticsExport: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully exported analytics data. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: components["schemas"]["DocumentsAnalyticsExportResponse"];
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  getApiConnections: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully retrieved the list of all connections. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: components["schemas"]["Connection"][];
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  getApiConnectionsByCustomerId: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        customerId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully retrieved the list of connections for the customer. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: components["schemas"]["Connection"][];
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  postApiConnectionsByCustomerIdByTargetSystemArchive: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        customerId: string;
        targetSystem: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully started the connection archival workflow. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: {
              /** @description The customer ID */
              customerId: string;
              /**
               * @description The status of the operation
               * @constant
               */
              status: "started";
              /** @description The target system */
              targetSystem: string;
              /** @description The ID of the archival workflow */
              workflowId: string;
            };
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description Connection not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  getApiCustomers: {
    parameters: {
      query?: {
        limit?: number;
        page?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully retrieved the list of customers. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: components["schemas"]["Customer"][];
            pagination: components["schemas"]["PaginationInfo"];
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  getApiCustomersByCustomerIdBills: {
    parameters: {
      query?: {
        billDateFrom?: string;
        hasFile?: boolean;
        limit?: number;
        offset?: number;
        sortBy?: "billDate" | "createdAt" | "updatedAt";
        sortOrder?: "asc" | "desc";
        updatedAfter?: string;
      };
      header?: never;
      path: {
        customerId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully retrieved bills. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: components["schemas"]["Bill"][];
            pagination: components["schemas"]["PaginationInfo"];
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  getApiCustomersByCustomerIdBillsByBillId: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        billId: string;
        customerId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully retrieved the bill. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: components["schemas"]["Bill"];
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  getApiCustomersByCustomerIdBillsByBillIdFile: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        billId: string;
        customerId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully downloaded the bill file. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/octet-stream": unknown;
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  "getApiCustomersByCustomerIdBillsByBillIdFile-url": {
    parameters: {
      query?: never;
      header?: never;
      path: {
        billId: string;
        customerId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully generated pre-signed URL. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: components["schemas"]["FileUrlResponse"];
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  getApiCustomersByCustomerIdBillsSync: {
    parameters: {
      query?: {
        forceFullFetch?: boolean;
      };
      header?: never;
      path: {
        customerId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully enqueued bills sync workflow instances for all active connections. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: {
              /** @description Number of workflow instances created */
              enqueuedCount: number;
              /** @description Target systems that were synced */
              targetSystems: string[];
              /** @description Array of workflow instance IDs */
              workflowIds: string[];
              /** @description The type of workflow that was enqueued */
              workflowType: string;
            };
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  getApiCustomersByCustomerIdDump: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        customerId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully retrieved the customer state. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: components["schemas"]["DumpData"];
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  getApiCustomersByCustomerIdFiles: {
    parameters: {
      query?: {
        limit?: number;
        offset?: number;
      };
      header?: never;
      path: {
        customerId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully retrieved files. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: components["schemas"]["File"][];
            pagination: components["schemas"]["PaginationInfo"];
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  "getApiCustomersByCustomerIdFilesBy-hash": {
    parameters: {
      query: {
        file_hash: string;
      };
      header?: never;
      path: {
        customerId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully retrieved bills and invoices for the file hash. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: components["schemas"]["FileHashReferencesResponse"];
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid file hash parameter. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  getApiCustomersByCustomerIdFilesSync: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        customerId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully enqueued files sync workflow. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: {
              /** @description The workflow instance ID */
              workflowId: string;
              /** @description The type of workflow that was enqueued */
              workflowType: string;
            };
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  getApiCustomersByCustomerIdInvoices: {
    parameters: {
      query?: {
        hasFile?: boolean;
        invoiceDateFrom?: string;
        limit?: number;
        offset?: number;
        sortBy?: "invoiceDate" | "createdAt" | "updatedAt";
        sortOrder?: "asc" | "desc";
        updatedAfter?: string;
      };
      header?: never;
      path: {
        customerId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully retrieved invoices. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: components["schemas"]["Invoice"][];
            pagination: components["schemas"]["PaginationInfo"];
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  getApiCustomersByCustomerIdInvoicesByInvoiceId: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        customerId: string;
        invoiceId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully retrieved the invoice. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: components["schemas"]["Invoice"];
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  getApiCustomersByCustomerIdInvoicesByInvoiceIdFile: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        customerId: string;
        invoiceId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully downloaded the invoice file. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/octet-stream": unknown;
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  "getApiCustomersByCustomerIdInvoicesByInvoiceIdFile-url": {
    parameters: {
      query?: never;
      header?: never;
      path: {
        customerId: string;
        invoiceId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully generated pre-signed URL. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: components["schemas"]["FileUrlResponse"];
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  getApiCustomersByCustomerIdInvoicesSync: {
    parameters: {
      query?: {
        forceFullFetch?: boolean;
      };
      header?: never;
      path: {
        customerId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully enqueued invoices sync workflow instances for all active connections. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: {
              /** @description Number of workflow instances created */
              enqueuedCount: number;
              /** @description Target systems that were synced */
              targetSystems: string[];
              /** @description Array of workflow instance IDs */
              workflowIds: string[];
              /** @description The type of workflow that was enqueued */
              workflowType: string;
            };
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  "postApiCustomersByCustomerIdSetup-schedule": {
    parameters: {
      query?: never;
      header?: never;
      path: {
        customerId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully set up workflow schedules. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: {
              /** @description Detailed message about the operation result */
              message: string;
              /**
               * @description Status of the setup operation
               * @enum {string}
               */
              status: "completed" | "error";
            };
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  "getApiTarget-systems": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully retrieved the list of target systems */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: components["schemas"]["TargetSystem"][];
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description The requested resource was not found. */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  "getApiTarget-systemsByTargetSystemId": {
    parameters: {
      query?: never;
      header?: never;
      path: {
        targetSystemId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Successfully retrieved the target system */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            data: components["schemas"]["TargetSystem"];
            /**
             * @description Indicates if the API request was successful.
             * @example true
             * @constant
             */
            success: true;
          };
        };
      };
      /** @description Invalid request parameters or malformed request body. */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse400"];
        };
      };
      /** @description HMAC authentication failed or missing authentication headers. */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse401"];
        };
      };
      /** @description Target system not found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse404"];
        };
      };
      /** @description An unexpected internal server error occurred while processing the request. */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ErrorResponse500"];
        };
      };
    };
  };
  getRedirectByCustomerIdByTargetSystem: {
    parameters: {
      query: {
        historicalStartDate: string;
      };
      header?: never;
      path: {
        customerId: string;
        targetSystem: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: never;
  };
}
export enum ApiPaths {
  getRedirectByCustomerIdByTargetSystem = "/redirect/{customerId}/{targetSystem}",
  getApiAnalyticsExport = "/api/analytics/export",
  getApiConnections = "/api/connections",
  getApiConnectionsByCustomerId = "/api/connections/{customerId}",
  postApiConnectionsByCustomerIdByTargetSystemArchive = "/api/connections/{customerId}/{targetSystem}/archive",
  getApiCustomers = "/api/customers",
  getApiCustomersByCustomerIdBills = "/api/customers/{customerId}/bills",
  getApiCustomersByCustomerIdBillsSync = "/api/customers/{customerId}/bills/sync",
  getApiCustomersByCustomerIdBillsByBillId = "/api/customers/{customerId}/bills/{billId}",
  getApiCustomersByCustomerIdBillsByBillIdFile = "/api/customers/{customerId}/bills/{billId}/file",
  getApiCustomersByCustomerIdBillsByBillIdFile_url = "/api/customers/{customerId}/bills/{billId}/file-url",
  getApiCustomersByCustomerIdInvoices = "/api/customers/{customerId}/invoices",
  getApiCustomersByCustomerIdInvoicesSync = "/api/customers/{customerId}/invoices/sync",
  getApiCustomersByCustomerIdInvoicesByInvoiceId = "/api/customers/{customerId}/invoices/{invoiceId}",
  getApiCustomersByCustomerIdInvoicesByInvoiceIdFile = "/api/customers/{customerId}/invoices/{invoiceId}/file",
  getApiCustomersByCustomerIdInvoicesByInvoiceIdFile_url = "/api/customers/{customerId}/invoices/{invoiceId}/file-url",
  getApiCustomersByCustomerIdFiles = "/api/customers/{customerId}/files",
  getApiCustomersByCustomerIdFilesSync = "/api/customers/{customerId}/files/sync",
  getApiCustomersByCustomerIdFilesBy_hash = "/api/customers/{customerId}/files/by-hash",
  getApiCustomersByCustomerIdDump = "/api/customers/{customerId}/dump",
  postApiCustomersByCustomerIdSetup_schedule = "/api/customers/{customerId}/setup-schedule",
  getApiTarget_systems = "/api/target-systems",
  getApiTarget_systemsByTargetSystemId = "/api/target-systems/{targetSystemId}",
}
